module.exports = __webpack_public_path__ + "img/87a573b.png";